import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { CMA_SUPPORT_URL } from '../apiConfig'

export const updateResolution = createAsyncThunk(
  'updateResolution',
  async ({ jwt_token, requestBody }) => {
    console.log('Request Body - ', requestBody)
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + jwt_token,
        'Content-Type': 'application/json' // Set content type to JSON
      },
      // body: JSON.stringify({ inventory_json: requestBody }) // Wrap requestBody as needed
      body: JSON.stringify(requestBody) // Wrap requestBody as needed
    }

    try {
      const response = await fetch(
        `${CMA_SUPPORT_URL}update/ticket/resolution/`,
        options
      )
      console.log('Request Options - ', options)
      console.log('Response -- ', response)
      return response.json() // Assuming the response is JSON
    } catch (error) {
      console.log('Error', error)
      alert(error.message)
      throw error
    }
  }
)

const updateResolutionSlice = createSlice({
  name: 'updateResolution',
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
    errorMessage: null
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(updateResolution.pending, state => {
      state.isLoading = true
      state.isError = false
      state.errorMessage = null
    })
    builder.addCase(updateResolution.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
      state.isError = false
      state.errorMessage = null
    })
    builder.addCase(updateResolution.rejected, (state, action) => {
      state.isLoading = false
      state.isError = true
      state.errorMessage = action.error.message
    })
  }
})

export default updateResolutionSlice.reducer
